import { cloneDeep } from 'lodash'
import { useModal } from '../../../../../hooks/useModal'
import { useRequestsHandlerData } from '../../../../../hooks/useRequestsHandlerData'
import useStateControls from '../../../../../hooks/useStateControls'
import useModalsAfterEnd from './useModalsAfterEnd'
import { FRIENDS } from '../../../../../constants/shared/states/names'
import { useContent, useWishes } from '../../../../../redux/reducer/content'
import content from '../../constants/content'
import { BUTTONS, IMAGE, TITLE, USER_BILLET } from '../../../../modals/universalModal'
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks'

const { extraProfileModal } = content

export default function useSendWishData({ chooseElf }) {
  const { data: wishData } = useWishes()
  const {
    viewedFriend,
    viewedFriend: { uid: userUid },
  } = useContent()
  const callbacks = useApplicationCallbacks()
  const { closeModal, addModal } = useModal()
  const { setState } = useStateControls()
  const createModalsAfterEnd = useModalsAfterEnd()

  useRequestsHandlerData([
    {
      address: 'requestsUserGetWishUserData',
      fulfilled() {
        closeModal('all')
      },
      rejected() {
        closeModal('all')
        setState(FRIENDS)
      },
    },
    {
      address: 'requestsWishSend',
      fulfilled() {
        closeModal('all')
        createModalsAfterEnd()
      },
      rejected() {
        callbacks.setWishErrorName({ name: wishData.name })
        chooseElf(wishData.image)
      },
    },
  ])

  return () => {
    const { image, name, text } = wishData ?? {}
    const {
      title,
      buttons: [send, close],
    } = cloneDeep(extraProfileModal)

    const callbackOptions = {
      name,
      uid: userUid,
      wishId: image?.id,
      wishTextId: text?.id,
      elf: wishData?.elf?.id,
    }

    addModal({
      type: 'universalModal',
      props: {
        modalProps: {
          wrapper: { isFullPage: false },
          modifier: 'noFullNoScroll',
        },
        components: [
          {
            list: [
              {
                type: TITLE,
                props: { modifier: ['padding-no', 'middleMar'], value: title },
              },
              {
                type: USER_BILLET,
                props: {
                  modifier: ['full-width'],
                  userData: viewedFriend,
                  onClick() {
                    callbacks.setIsVisible(true)
                    addModal({ type: 'profileModal' })
                  },
                },
              },
              {
                type: IMAGE,
                props: {
                  modifier: ['width-card', 'rounded'],
                  img: wishData?.elf?.image,
                },
              },
              {
                type: BUTTONS,
                props: { buttons: [{ ...send, callbackOptions }, close] },
              },
            ],
          },
        ],
      },
    })
  }
}
